import { render, staticRenderFns } from "./partnerSearch.vue?vue&type=template&id=315fb21d&"
import script from "./partnerSearch.vue?vue&type=script&lang=js&"
export * from "./partnerSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports